









import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Error extends Vue {
  private get error(): any {
    return this.$store.state.app.error;
  }

  private mounted(): void {
    this.$nextTick(() => {
      this.$bus.$emit('progress-stop');
    });
  }

  private beforeDestroy(): void {
    this.$store.commit('app/error', {});
  }
}
